import { render, staticRenderFns } from "./CoreImportPickPlaceTable.vue?vue&type=template&id=545fdc5c"
import script from "./CoreImportPickPlaceTable.vue?vue&type=script&lang=js"
export * from "./CoreImportPickPlaceTable.vue?vue&type=script&lang=js"
import style0 from "./CoreImportPickPlaceTable.vue?vue&type=style&index=0&id=545fdc5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CoreImportPickPlaceTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports